import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Home from "../components/Home/Home";
import Biography from "../pages/Biography";
import Projects from "../pages/Projects";
import ProjectsDetails from "../pages/ProjectsDetails";
import Coaching from "../pages/Coaching";
import About from "../pages/About";
import Contact from "../pages/Contact";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfUse from "../pages/TermsOfUse";
import ScrollToTop from "../pages/ScrollToTop";
import ManagementBoard from "../pages/ManagementBoard";
import News from "../pages/News";
import Statistika from "../pages/Statistika";
import SubsEmployee from "../pages/SubsEmployee";
import SubsCompany from "../pages/SubsCompany";
import InvestClub from "../pages/InvestClub";
import NewsDetails from "../pages/NewsDetails";
import Login from "../pages/account/Login";
import Register from "../pages/account/Register";
import JobPostings from "../pages/JobPostings";
import Dashboard from "../pages/account/Dashboard";
import Admin from "../pages/account/Admin";
import CvBank from "../pages/CvBank";
import JobPostingsDetails from "../pages/JobPostingsDetails";
import CvDetails from "../pages/CvDetails";
import CoachingDetails from "../pages/CoachingDetails";
import SubsCoaching from "../pages/SubsCoaching";
import New from "../pages/New";
import AllTestimonials from "../pages/AllTestimonials";
import AllDate from "../pages/AllDate";

const AppRouter = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/biography" element={<Biography />}></Route>
          {/* <Route path="/about" element={<About/>}></Route> */}
          {/* <Route path="/managementboard" element={<ManagementBoard/>}></Route> */}
          {/* <Route path="/statistics" element={<Statistika/>}></Route> */}
          <Route path="/investclub" element={<InvestClub />}></Route>
          <Route path="/new" element={<New />}></Route>
          <Route path="/news/:newsId" element={<News />}></Route>
          <Route path="/:newsDetailsId" element={<NewsDetails />}></Route>
          <Route path="/employee" element={<SubsEmployee />}></Route>
          <Route path="/company" element={<SubsCompany />}></Route>
          <Route path="/coachingsubs" element={<SubsCoaching />}></Route>

          <Route path="/jobpostings" element={<JobPostings />}></Route>
          <Route
            path="/jobdetails/:jobId"
            element={<JobPostingsDetails />}
          ></Route>

          <Route path="/resume" element={<CvBank />}></Route>
          <Route path="/resume/:resumeId" element={<CvDetails />}></Route>

          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/admin" element={<Admin />}></Route>

          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
          <Route path="/termsofuse" element={<TermsOfUse />}></Route>
          <Route path="/projects" element={<Projects />}></Route>
          <Route
            path="/projects/:projectsId"
            element={<ProjectsDetails />}
          ></Route>
          <Route path="/coaching" element={<Coaching />}></Route>
          <Route
            path="/coachings/:coachingId"
            element={<CoachingDetails />}
          ></Route>
          <Route path="/feedbacks" element={<AllTestimonials />}></Route>
          <Route path="/chronology" element={<AllDate />}></Route>


          {/* ACCOUNT */}
          <Route path="/signin" element={<Login />}></Route>
          <Route path="/signup" element={<Register />}></Route>
        </Routes>
       
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default AppRouter;
